/**
 * Sum bucket arrays from GET /api/stats/chart response.
 * Totals match the org pipeline graph for the selected range (sum of per-bucket values).
 * @param {{ outreach?: number[], responses?: number[], meetings?: number[] } | null | undefined} bundle
 */
export function sumChartSeries(bundle) {
  if (!bundle || typeof bundle !== "object") {
    return { outreach: 0, responses: 0, meetings: 0 };
  }
  const sum = (arr) => (Array.isArray(arr) ? arr.reduce((a, x) => a + Number(x ?? 0), 0) : 0);
  return {
    outreach: sum(bundle.outreach),
    responses: sum(bundle.responses),
    meetings: sum(bundle.meetings),
  };
}
